import { reviews } from '@/mocks/reviews';

export default function ReviewSection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <span className="inline-block px-3 py-1 border border-background-300/50 text-foreground-400 text-xs rounded-full mb-4 whitespace-nowrap">
          读者热评
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-100 mb-2">漫迷们都在说</h2>
        <p className="text-foreground-500 text-sm mb-8">听听读者们对热门漫画的真实评价</p>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-5">
          {reviews.map((review) => (
            <div key={review.id} className="break-inside-avoid mb-4 md:mb-5 bg-background-200/70 rounded-xl p-5">
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={review.avatar}
                  alt={review.username}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                  loading="lazy"
                />
                <div>
                  <p className="text-foreground-200 text-sm font-bold">{review.username}</p>
                  <p className="text-foreground-600 text-xs">{review.handle}</p>
                </div>
                <div className="ml-auto flex items-center gap-0.5">
                  {Array.from({ length: review.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                  ))}
                </div>
              </div>
              <p className="text-foreground-400 text-sm leading-relaxed">{review.content}</p>
              <p className="mt-3 text-foreground-600 text-xs">
                评《{review.comicTitle}》 · {review.date}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}